import { ConfirmProvider, EditTabsPattern } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import { ConfigData, History, SettingsTab } from './tabs'

const tabs = [
  { component: <SettingsTab />, name: 'settings' },
  { component: <History />, name: 'version' },
  { component: <ConfigData />, name: 'Config' },
]

export const Introduction = () => {
  const { componentID, useUrl } = useComponentProvider()
  return (
    <ConfirmProvider>
      <EditTabsPattern
        defaultTab="settings"
        showTabs={!!componentID}
        tabs={tabs}
        urlParams={useUrl}
      />
    </ConfirmProvider>
  )
}
